const messages = {
    en: {
      home: "Home",
      test: "Test",
      testYourKnow: "Test your knoweledge",
      login: "Login",
      register: "Sign up",
      logout: "Logout",
      testResults: "Test results",
      users: "Users",
      subjects: "Subjects",
      admin: "Admin",
      hi: "Hi, ",
      settings: "Settings",
      contibute: "Contribute",
      makeContribution: "Make contribution",
      myContrributionStatus: "My contribution status",
      globalSettings: "Global settings",
      contribution: "Contribution",
      addQuestion: "Add question",
      editQuestion: "Edit question",
      changePassword: "Change password",
      searchForQusestion: "Search for question",
      mistakes: "My mistakes"

    },
    ru: {
      home: "Домой",
      test: "Teст",
      testYourKnow: "Проверьте свои знания",
      login: "Логин",
      register: "Зарегистрироваться",
      logout: "Выход",
      testResults: "Результаты теста",
      users: "Пользователи",
      subjects: "Предметы",
      admin: "Админ",
      hi: "Привет, ",
      settings: "Настройки",
      contibute: "Мои вопросы",
      makeContribution: "Добавить вопросы",
      myContrributionStatus: "Cтатус моих вопросов",
      globalSettings: "Глобальные настройки",
      contribution: "Вклад пользователей",
      addQuestion: "Добавить вопрос",
      editQuestion: "Редактировать вопрос",
      changePassword: "Cменить пароль",
      searchForQusestion: "Поиск вопроса",
      mistakes: "Мои ошибки"
    }
  };

  export default messages;